import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  RequestTypes,
  registerItemKeys,
} from '@core/react-query/features/registers/registers/register/items/item'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { registerItemsKeys } from '@core/react-query/features/registers/registers/register/items'
import { IRegisterItem } from '@core/entities/register/RegisterItem'

export const useUpdateRegisterItemAnnotations = (
  options?: UseMutationOptions<
    IRegisterItem,
    RequestErrorType,
    RequestTypes['updateRegisterItemAnnotations']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...registerItemKeys.updateRegisterItemAnnotations,
    ...options,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries(registerItemsKeys.itemsByRegisterId._def)
      queryClient.invalidateQueries(registerItemKeys.byId({ ...variables }))
    },
  })
}
